import { Box, Stack } from '@mui/material';
import { useEffect, useState } from 'react';

import { doInit2factorAuth, useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { getPreviewBeforeStopCopy } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { getViewFullInfoByAccountId } from '@/utilities';
import RadioButtonsGroup from '@/views/components/componentsUI/GroupRadio';
import ButtonElement from '@/views/elements/button/ButtonElement';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import classNames from 'classnames/bind';
import { DataOnParents, KeyDataParents } from '../RegisterFollower/RegisterFollower';
import styles from './Step1.scss';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

export type RadioStopCopy = "TRANS" | "SELL"

const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const { dataMasterTrade } = data
    const { Step1 }: { Step1: any } = dataOnParents


    const [type, setType] = useState('TRANS')
    const [dataPreview, setDataPreview] = useState<any>({})

    useEffect(() => {
        if (Step1?.isSaved === true) {
            setType(Step1?.type)
        }
    }, [])

    useEffect(() => {
        async function callApiGetPreviewBeforeStopCopy() {
            const { isSuccess, data } = await getPreviewBeforeStopCopy({ accountId: refaccount, masterAccount: dataMasterTrade?.afacctno })
            if (isSuccess) {
                setDataPreview(data)
            }
        }
        callApiGetPreviewBeforeStopCopy()
    }, [refaccount])


    const handleNext = async () => {
        // console.log('ha_check_dataPreview', dataPreview);
        setStateLoadingAction(true)
        const { isSuccess, data } = await doInit2factorAuth()
        setStateLoadingAction(false)
        if (isSuccess && Object.hasOwn(data, 'transactionId')) {
            handleSaveDataOnParents("Step1", {
                isSaved: true,
                type,
                linkAccount: dataPreview?.linkaccount
            })
            handleSaveDataOnParents("dataVerify", data);
            next()
        }
    }

    return (
        <Box className="Step1" sx={{ height: "60vh", overflow: 'auto', px: '10px' }}>
            <Stack
                direction={"column"}
                spacing={1}
            >
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.common.masterTrader")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='primary'>
                            {dataPreview?.mt_fullname}
                        </TypographyElement>
                    </Box>

                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.investAmount")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.copied_value} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.remainingAmount")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.cash} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.stockValue")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.equity} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.common.pnl")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' displayType='text' isCheckPNL={true} value={dataPreview?.num_interest} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.common.ppnl")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat displayType='text' isPercentage={true} isCheckPNL={true} align='right' value={dataPreview?.percentage_num_interest} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.copyDays")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' displayType='text' isCheckPNL={true} value={dataPreview?.num_day_copy} />
                    </Box>
                </Stack>

                <Box sx={{ borderTop: "1px solid ", height: 10, borderColor: 'text.secondary' }}></Box>


                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.feeNow", { value: dataPreview?.numdaynotpayfee })}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.mngfeenotpayment} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.loanFee")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.feenotpayment} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.allFee")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.mngfeenotpayment + dataPreview?.feenotpayment} />
                    </Box>
                </Stack>

                <Box sx={{ borderTop: "1px solid ", height: 10, borderColor: 'text.secondary' }}></Box>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.cashAfter")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={dataPreview?.netcashafterfee} />
                    </Box>
                </Stack>


                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' ColorElement='secondary'>
                            {t("copytrade.stopCopy.linkAccount")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <TypographyElement TextAlignElement='end' ColorElement='primary' FontWeightElement={400} FontSizeElement='14px'>{getViewFullInfoByAccountId(dataPreview?.linkaccount)}</TypographyElement>
                    </Box>
                </Stack>

                <Box sx={{ borderTop: "1px solid ", height: 10, borderColor: 'text.secondary' }}></Box>


                <Box>
                    <RadioButtonsGroup
                        data={[
                            { label: t("copytrade.stopCopy.option1"), value: "TRANS" },
                            { label: t("copytrade.stopCopy.option2"), value: 'SELL' }
                        ]}
                        value={type}
                        onTransferValue={(value: any) => setType(value)}
                    />
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => close()} >{t("copytrade.common.close")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.next")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1